export const NPVR_NOT_RECORDABLE_EVENT_STATUS = 0;

export const NPVR_RECORDABLE_EVENT_STATUS = 1;
export const NPVR_RECORDABLE_EVENT_STATUS_CANCEL = '1_cancel';

export const NPRV_SCHEDULED_STATUS = 2;
export const NPRV_SCHEDULED_STATUS_CANCEL = '2_cancel';
export const NPRV_SCHEDULED_STRING = 'scheduled';
export const NPRV_SCHEDULED_STRING_CANCEL = 'scheduled_cancel';


export const NPVR_RECORDING_STATUS = 3;
export const NPVR_RECORDING_STATUS_CANCEL = '3_cancel';
export const NPVR_RECORDING_STRING = 'recording';
export const NPVR_RECORDING_STRING_CANCEL = 'recording_cancel';


export const NPVR_RECORDED_STATUS = 4;
export const NPVR_RECORDED_STATUS_CANCEL = '4_cancel';
export const NPVR_RECORDED_STRING = 'ingested';
export const NPVR_RECORDED_STRING_CANCEL = 'ingested_cancel';

export const NPVR_ERROR_RECORDING_STATUS = 5;
export const VCARD_NPVR_RECORDED = 'vcard';

export const NPVR_ERROR = 'ERROR';

export const NPVR_NO_SPACE_TO_RECORD_ERROR_CODE = 'PLY_REC_00014';


// WEBPACK FOOTER //
// ./src/AAF/Npvr/Constans.js